<template>
  <FlexLayout>
    <BlockContainer>
      <template #actions>
        <div v-for="item in links" :key="item.key">
          <Button :icon-left="item.icon" :action="item.action" lg class="dashboard-item">{{ item.name() }}</Button>
        </div>
      </template>
    </BlockContainer>
  </FlexLayout>
</template>

<script>
import {useAppStore} from "@/stores/app";
import {Mode, Workflow} from "@/constants/constants";
import Button from "@/components/actions/Button.vue";
import {useAuthStore} from "@/stores/auth";
import FlexLayout from "@/components/layout-components/Main/FlexLayout.vue";
import BlockContainer from "@/components/layout/BlockContainer.vue";
import {canAccessRouteName} from "@/utils/authRouteUtils";

export default {
  components: {BlockContainer, FlexLayout, Button},
  data() {
    return {
      items:[
        {key: 0, name: ()=>'Template', action: this.navigateToTemplate, icon: 'user', visible: ()=> process.env.NODE_ENV !== 'production'},
          {key: 1, name: ()=>this.$t('customerCard.title'), action: this.navigateToCustomerCard, icon: 'qrcode', visible: ()=>this.canAccessRoute('CustomerCard')},
          {key: 2, name: ()=>this.$t('account.title'), action: this.navigateToAccount, icon: 'user', visible: ()=>this.canAccessRoute('Account')},
          {key: 3, name: ()=>this.$t('orderMenu.title'), action: this.navigateToOrder, icon: 'burger', visible: ()=>this.canAccessRoute('OrderMenuParameters')},
          {key: 4, name: ()=>this.$t('mealPlan.title'), action: this.navigateToMealPlan, icon: 'calendar-days', visible: ()=>this.canAccessRoute('MealPlanParameters')},
          {key: 5, name: ()=>this.$t('orderHistory.title'), action: this.navigateToOrderHistory, icon: 'rectangle-list', visible: ()=>this.canAccessRoute('OrderHistory')},
          {key: 6, name: ()=>this.$t('transactionHistory.title'), action: this.navigateToTransactionHistory, icon: 'receipt', visible: ()=>this.canAccessRoute('TransactionHistory')},
          {key: 7, name: ()=>this.$t('studentAccounts.title'), action: this.navigateToStudentAccounts, icon: 'user-graduate', visible: ()=>this.canAccessRoute('StudentAccounts')},
      ],
    };
  },
  computed: {
    config() {
      return window.config;
    },
    links(){
      return this.$data.items.filter(function(item){return item.visible===undefined || item.visible();});
    },
  },
  setup() {
    const authStore = useAuthStore();
    const appStore = useAppStore();

    return {
      authStore,
      appStore
    };
  },
  methods: {
    canAccessRoute(routeName) {
      return canAccessRouteName(this.authStore, this.config, routeName);
    },
    navigateToTemplate() {
      this.$navigateToTemplate();
    },
    navigateToAccount() {
      this.$navigateToAccount();
    },
    navigateToOrder() {
      this.appStore.setWorkflow(Workflow.ORDER);
      if (this.appStore.isMode(Mode.TABLE) || this.appStore.isMode(Mode.TAKEAWAY)) {
        this.$navigate(this.appStore.orderEntryRouteName || this.appStore.tableOrderEntryRouteName || 'OrderMenuPlanner', { withReplace: true });
        return;
      }
      this.$navigateToOrderMenuParameters();

    },
    navigateToMealPlan() {
      this.appStore.setWorkflow(Workflow.MEAL_PLAN);
      this.$navigateToMealPlanParameters();
    },
    navigateToCustomerCard() {
      this.appStore.setWorkflow(Workflow.TOP_UP);
      this.$navigateToCustomerCard();
    },
    navigateToTransactionHistory() {
      this.$navigateToTransactionHistory();
    },
    navigateToOrderHistory() {
      this.$navigateToOrderHistory();
    },
    navigateToStudentAccounts() {
      this.appStore.setWorkflow(Workflow.SCHOOL);
      this.$navigateToStudentAccounts();
    },
  },
};
</script>

<style scoped>
.dashboard-item {
  flex: 1 1 calc(30% - 20px); /* Responsive width with some margin */
  padding: 20px;
  display: flex;
  align-items: center; /* Vertically center icon and title */
  cursor: pointer;
  transition: background-color 0.3s;
  gap: 20px;
}

</style>
